module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "definition-bracket",
    class: _vm.classes,
    attrs: {
      "draggable": _vm.isDraggable
    },
    on: {
      "dragstart": _vm.dragStartHandler,
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler,
      "dragend": _vm.dragEndHandler
    }
  }, [_c('svg-icon', {
    key: _vm.attribute.definitionId,
    attrs: {
      "icon": _vm.icon
    },
    nativeOn: {
      "click": function($event) {
        return _vm.select(_vm.attribute)
      }
    }
  }), _vm._v(" "), (_vm.showMustMatch) ? _c('span', {
    staticClass: "definition-bracket__count-group",
    on: {
      "dblclick": _vm.clickHandler
    }
  }, [_vm._v(_vm._s(_vm.attribute.mustMatch))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-513f3d90","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/targetDefinition/components/targetDefinitionStatement/DefinitionBracket.vue
// module id = 2081
// module chunks = 0